import React from 'react';

interface StructuredItem {
  heading: string;
  content: string;
}

interface StructuredFieldEditorProps {
  label: string;
  field: string;
  items: StructuredItem[];
  onChange: (items: StructuredItem[]) => void;
  errors?: string[];
}

const StructuredFieldEditor: React.FC<StructuredFieldEditorProps> = ({
  label,
  items,
  onChange,
  errors,
}) => {
  const handleAdd = () => {
    onChange([...items, { heading: '', content: '' }]);
  };

  const handleChange = (index: number, field: 'heading' | 'content', value: string) => {
    const newItems = [...items];
    newItems[index] = { ...newItems[index], [field]: value };
    onChange(newItems);
  };

  const handleRemove = (index: number) => {
    const newItems = items.filter((_, i) => i !== index);
    onChange(newItems);
  };

  return (
    <div className="form-group mb-3">
      <label className="form-label fw-semibold">{label}</label>
      <div className="mb-2">
        <button
          type="button"
          className="btn btn-sm btn-outline-primary"
          onClick={handleAdd}
        >
          <i className="fas fa-plus"></i> 追加
        </button>
      </div>
      <div className="items-container">
        {items.map((item, index) => (
          <div key={index} className="nested-fields mb-3 p-3 border rounded">
            <div className="row">
              <div className="col-11">
                <div className="form-group mb-2">
                  <label className="form-label">見出し</label>
                  <input
                    type="text"
                    className={`form-control ${errors ? 'is-invalid' : ''}`}
                    value={item.heading}
                    onChange={(e) => handleChange(index, 'heading', e.target.value)}
                    placeholder="見出しを入力してください"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">本文</label>
                  <textarea
                    className={`form-control ${errors ? 'is-invalid' : ''}`}
                    value={item.content}
                    onChange={(e) => handleChange(index, 'content', e.target.value)}
                    rows={3}
                    placeholder="本文を入力してください"
                  />
                </div>
              </div>
              <div className="col-1 d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => handleRemove(index)}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      {errors && errors.length > 0 && (
        <div className="invalid-feedback d-block">{errors.join(', ')}</div>
      )}
    </div>
  );
};

export default StructuredFieldEditor;



